import axios from "axios";

// Strip any trailing slash so `${BACKEND_URL}/api/...` never produces a double-slash.
// (Production env var was set to "https://avianayoga.com/" which caused every
// /api/files/... URL to resolve to the index HTML page instead of the image.)
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Token fallback so auth works even if 3rd-party cookies are blocked
const TOKEN_KEY = "aviana_token";
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
}
// Bootstrap on load
const _saved = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
if (_saved) api.defaults.headers.common["Authorization"] = `Bearer ${_saved}`;

// Global 401 handler — when the session expires we route the user to /login
// with a return-URL so they pick up exactly where they left off (critical for
// long-form workflows like quiz authoring).
api.interceptors.response.use(
  (r) => r,
  (err) => {
      if (err?.response?.status === 401 && typeof window !== "undefined") {
        const path = window.location.pathname + window.location.search;
        // Don't loop if we're already on /login
        if (!path.startsWith("/login") && !err.config?.url?.endsWith("/auth/me")) {
          setAuthToken(null);
          sessionStorage.setItem("aviana_return_to", path);
          window.location.href = "/login?session=expired";
        }
      }
      // Access-expired responses (402) — bounce to the dashboard so students
      // can request an extension. Detected via the `code: "access_expired"`
      // payload emitted by `_lms_require_enrollment` in core.py.
      if (err?.response?.status === 402 && typeof window !== "undefined") {
        const detail = err.response?.data?.detail;
        if (detail && detail.code === "access_expired" && !window.location.pathname.startsWith("/dashboard")) {
          window.location.href = "/dashboard?access=expired";
        }
      }
      return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
